module.exports = __webpack_public_path__ + "img/danghuan-logo.c26e1dc9.png";